import AjaxLoad from '../../../lib/ajax-load';
import { checkAndLoadFiles } from '../../../js/helper';

class TabNavigation {
    constructor ($element, options) {
        this.$tabNav = $element;
        this.wait = false;
        this.$productImage = document.querySelector('[data-product-image]');
        this.$productIntro = document.querySelector('.product-detail .grid-container');
        this.$languageSwitch = document.querySelector('[data-language-switch]');
        this.$tabLanguage = document.querySelector('[data-tab-language]');

        const settings = {
            onSubmitted: null,
            target: document.querySelector('[data-tab-nav="target"]')
        };

        this.settings = Object.assign({}, settings, options);
        this.tabNames = {};
    }

    initialize () {
        this.prepareData();
        this.setEvents();

        if (this.$tabLanguage) {
            window.setTimeout(() => {
                this.checkAndSetLanguageNavigation(this.$tabLanguage);
            }, 250);
        }
    }

    prepareData () {
        const $$tabNavs = this.$tabNav.querySelectorAll('[data-tab-nav-key]');

        if ($$tabNavs.length > 0) {
            $$tabNavs.forEach($tabNav => {
                const category = $tabNav.getAttribute('data-type');
                const value = $tabNav.getAttribute('data-tab-nav-key');

                this.tabNames[category] = {};
                this.tabNames[category].name = value;
                this.tabNames[category].params = '';
            });
        }
    }

    setEvents () {
        if (this.$tabNav) {
            this.$tabNav.addEventListener('click', (e) => {
                if (this.wait === false) {
                    e.preventDefault();

                    if (!e.target.classList.contains('is--active')) {
                        if (e.target.getAttribute('data-tab-nav') === 'item') {
                            const anchorPosition = this.$productIntro.offsetTop + this.$productIntro.offsetHeight + document.querySelector('.product-detail .tab-navigation').offsetHeight;
                            window.scrollTo({
                                top: anchorPosition,
                                behavior: 'smooth'
                            });
                            this.wait = true;
                            const type = e.target.getAttribute('data-type');
                            this.checkFixedImage(type);
                            this.updateUrl(type);
                            this.loadContent(e.target.getAttribute('data-href'), e.target);
                        }
                    }
                }
            });
        }

        // Fix tab navigation
        document.addEventListener('scroll', function (e) {
            const $tabNavigation = document.querySelector('.product-detail .tab-navigation');
            const tabNavigationHeight = $tabNavigation.offsetHeight;
            const $productContainer = document.querySelector('.product-detail__inner');
            const $gridContainer = document.querySelector('.product-detail .grid-container');

            if ($gridContainer.getBoundingClientRect().bottom <= 0) {
                $tabNavigation.classList.add('is--fixed');
                $productContainer.style.paddingTop = tabNavigationHeight + 'px';
            } else {
                $tabNavigation.classList.remove('is--fixed');
                $productContainer.style.paddingTop = '0px';
            }
        });
    }

    updateUrl (newTabName) {
        // Get the current URL
        const currentUrl = window.location.href;

        // Split the URL into its components
        const urlParts = currentUrl.split('/');

        // Get the last part of the URL (which may be a tab name)
        const lastPart = urlParts[urlParts.length - 1];
        const lastPartWithoutParams = lastPart.split('?')[0];

        // Check if the last part of the URL matches any tab name in the selected language
        const key = this.getKeyByValue(lastPartWithoutParams);

        if (key !== null) {
            if (lastPartWithoutParams !== lastPart) {
                this.tabNames[key].params = lastPart;
            }

            if (this.tabNames[newTabName]) {
                if (this.tabNames[newTabName].params !== '') {
                    urlParts[urlParts.length - 1] = this.tabNames[newTabName].params;
                } else {
                    urlParts[urlParts.length - 1] = this.tabNames[newTabName].name;
                }
            } else {
                // If no new tab name is provided, remove the current tab name from the URL
                urlParts.pop();
            }
        } else {
            if (this.tabNames[newTabName].params !== '') {
                urlParts.push(this.tabNames[newTabName].params);
            } else {
                urlParts.push(this.tabNames[newTabName].name);
            }
        }

        // Reassemble the URL from the parts
        let newUrl = urlParts.join('/');

        // Remove any trailing "/" at the end of the URL, if present
        newUrl = newUrl.replace(/\/+$/, '');

        // Update the browser's URL without reloading the page
        window.history.replaceState(null, '', newUrl);
    }

    getKeyByValue (value) {
        // Iterate through the entries of this.tabNames
        const matchedEntry = Object.entries(this.tabNames).find(([key, val]) => val.name === value);

        // Return the key if found, otherwise return null
        return matchedEntry ? matchedEntry[0] : null;
    }

    checkFixedImage (type) {
        if (type !== 'product') {
            this.$productImage.classList.remove('is--product-tab');
        } else {
            this.$productImage.classList.add('is--product-tab');
        }
    }

    createElementFromHTML (htmlString) {
        const div = document.createElement('div');
        div.innerHTML = htmlString.trim();

        if (div.children.length > 1) {
            const itemsArray = [];
            Array.prototype.push.apply(itemsArray, div.children);
            return itemsArray;
        } else {
            return div.firstChild;
        }
    }

    loadContent (url, tab) {
        this.settings.target.classList.add('is--loading');

        const ajaxLoad = new AjaxLoad(url, {
            requestMethod: 'GET',
            onSuccess: (resultText) => {
                this.setContent(this.createElementFromHTML(resultText));
                this.setActiveTab(tab, () => {
                    if (typeof this.settings.onSubmitted === 'function') {
                        this.settings.onSubmitted(this.settings.target);
                    }
                });

                // dispatch event for product product-detail.js
                const tabEvent = new Event('tabContentChange');
                document.dispatchEvent(tabEvent);

                checkAndLoadFiles(this.settings.target);
            }
        });

        ajaxLoad.initialize();
    }

    setActiveTab (tab, callback) {
        this.$tabNav.querySelector('[data-tab-nav="item"].is--active').classList.remove('is--active');
        tab.classList.add('is--active');

        if (typeof callback === 'function') {
            callback();
        }
    }

    setContent ($result) {
        this.settings.target.innerHTML = $result.innerHTML;

        this.checkAndSetLanguageNavigation(this.createElementFromHTML($result.innerHTML));

        setTimeout(() => {
            this.settings.target.classList.add('is--finished');
        }, 50);

        setTimeout(() => {
            this.settings.target.classList.remove('is--loading');
            this.settings.target.classList.remove('is--finished');
        }, 400);

        this.wait = false;
    }

    checkAndSetLanguageNavigation ($target) {
        const choicesAPI = this.$languageSwitch.choicesAPI;
        const currentSelectedValue = choicesAPI.choicesElement.getValue(true);
        const $orgElement = choicesAPI.$orgElement;

        const newOptionsArray = [];
        let newSelectedValue = currentSelectedValue;

        for (const option of $orgElement.options) {
            const newOption = {};

            newOption.label = option.label;
            newOption.selected = option.selected;

            if (typeof $target[0] === 'undefined' && $target.hasAttribute('data-href-de') && option.value.indexOf('/de-DE') !== -1) {
                newOption.value = option.value + '/' + $target.getAttribute('data-href-de');

                if (newOption.selected === true) {
                    newSelectedValue = newOption.value;
                }
            } else if (typeof $target[0] === 'undefined' && $target.hasAttribute('data-href-en')) {
                newOption.value = option.value + '/' + $target.getAttribute('data-href-en');

                if (newOption.selected === true) {
                    newSelectedValue = newOption.value;
                }
            } else {
                newOption.value = option.value;
            }

            if (newOption.selected === true) {
                newSelectedValue = newOption.value;
            }

            newOptionsArray.push(newOption);
        }

        choicesAPI.choicesElement.clearChoices();
        choicesAPI.choicesElement.setValue(newOptionsArray);
        choicesAPI.choicesElement.setChoiceByValue(newSelectedValue);
    }
}

export { TabNavigation };
